import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_CREATE_OFFER = async (data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/offer/create-offer",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_LIST_OFFER = async (params) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get("/offer/all-offers", {
      headers: {
        Authorization: `${authToken}`, // Add the Authorization header with the token
      },
      params: params, // Include dynamic params
    });
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_DELETE_OFFER = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.delete(
      `/offer/delete-offer/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_UPDATE_OFFER = async (data, id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/offer/update-offer/${id}`,
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_ENABLE_DISABLE_OFFER = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.put(
      `/offer/enable-disable-offer/${id}`,
      null, // No request body for this API call
      {
        headers: {
          Authorization: `${authToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
